const ALTERNATIVES_ID = 5;
const HEDGEFUNDS_ID = 6;

export default [ALTERNATIVES_ID, HEDGEFUNDS_ID];
